module.exports = __webpack_public_path__ + "static/img/bg-id.4a9a4301.png";